import React from "react";
import './index.css'


const Footer = () => {
  return (
    <div className="footer" style={{background: "linear-gradient(135deg, #004d4d, #002626)",}}>
      © {new Date().getFullYear()} UPL. All Rights Reserved.
    </div>
  );
};

export default Footer;
